import React from "react";
import { updatePlan } from "components/FormPlan/messages";
import { FormPlan } from "./FormPlan";
import withChallenge from "HOCs/withChallenge";
import App from "components/App";
import { Navbar } from "components/Navbar";
import { useChallenge } from "contexts/Challenge/useChallenge";
import Header from "../../Ranking/Header";
import MainCard from "components/MainCard";

const UpdatePlan = () => {
  const { configsPage } = useChallenge();

  return (
    <App>
      <Navbar backTo={configsPage} />
      <Header title={updatePlan} color="white" />
      <MainCard title={updatePlan} showBrandFooter>
        <FormPlan />
      </MainCard>
    </App>
  );
};

export default withChallenge(UpdatePlan);
